import { render } from "./HistogramChart.vue?vue&type=template&id=26b0347f"
import script from "./HistogramChart.vue?vue&type=script&lang=js"
export * from "./HistogramChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__